/* Etiquetas multiidoma en castellano. */
export default {
  "excursionNotFound.excursionNotFound": "No se ha podido encontrar la modalidad solicitada",
};
